import * as Yup from 'yup';

import { useSignIn } from '../../../hooks/useSignIn';

export const useSignInForm = ({ onSuccess }) => {
  const { signIn, isLoading } = useSignIn();
  const formSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
  });
  const initialValues = { email: '', password: '' };

  const onSubmit = (values, { setStatus, setSubmitting }) =>
    signIn(values)
      .then((result) => {
        // MFA-required sign-ins redirect to the challenge; don't fire onSuccess yet.
        if (result?.mfaRequired || result?.mfaSetupRequired) return;
        onSuccess(result);
      })
      .catch((error) => {
        setSubmitting(false);

        if (error.status === 401) {
          setStatus({ error: error?.data?.error });
        } else {
          setStatus({ error: 'There was an unexpected error, please try again or contact us.' });
        }
      });

  return {
    initialValues,
    formSchema,
    onSubmit,
    isLoading,
  };
};
